import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "font-montserrat flex justify-center items-center relative min-w-screen min-h-screen py-[50px] px-[10px] bg-gray-50" }
const _hoisted_2 = { class: "w-full flex justify-center items-center flex-col relative py-[50px] md:px-[20px] px-[10px] max-w-[600px] border-2 border-gray-300 h-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-1xl mb-[20px] text-center font-bold" }, "Connexion", -1)
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "w-full relative px-[10px] flex justify-center items-center" }
const _hoisted_6 = {
  key: 0,
  class: "text-red-500 w-full mx-[20px] m-[10px] p-[10px] relative border rounded-[5px] text-center bg-red-100/20"
}
const _hoisted_7 = { class: "py-[10px] w-full px-[10px] relative" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "text-sm font-bold left-[20px] text-black-500 absolute top-[12px]"
}, "Email", -1)
const _hoisted_9 = { class: "py-[10px] w-full px-[10px] relative" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "text-sm font-bold left-[20px] text-black-500 absolute top-[12px]"
}, "Mot de passe", -1)
const _hoisted_11 = ["type"]
const _hoisted_12 = { class: "py-[10px] w-full px-[10px] relative" }
const _hoisted_13 = { type: "submit" }
const _hoisted_14 = { class: "py-[10px] w-full px-[10px] flex justify-end items-center relative" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-gray-400 py-[50px] bg-gray-50 flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center font-bold text-sm" }, "© 2023 Cotonou Cadjehoun, Tous droits réservés.")
], -1)

import { ref, onMounted } from 'vue';
    import axios from 'axios';
    import { useRouter } from 'vue-router';
    import axiosInstance from '@/plugins/axios';

    
    
export default /*#__PURE__*/_defineComponent({
  __name: 'LogIn',
  setup(__props) {

    const pageTitle = ref('Log in');
    const showPassword = ref(false);
    const router = useRouter();

    function goToResetPage() {
      router.push('/resetPassword')
    }


    onMounted(() => {
        document.title = pageTitle.value;
    });

    const loading = ref(false);
    const errorMessage = ref("");
    const loginData = ref({
      email: '',
      password: '',
    });

    const loginUser = async () => {
      try {
        loading.value = true;
        const response = await axiosInstance.post('/auth/jwt/create/', loginData.value);
        const token = response.data.access;
        const errorMessage = ref(response.data);
        localStorage.setItem('token', token);
        errorMessage.value = response.data
        router.push('/dashboard');
      } catch (error) {
        console.error(error);
        errorMessage.value = 'Nom d\'utilisateur ou mot de passe incorrect';
      } finally {
        loading.value = false; 
      }
    };

    const refreshToken = async () => {
      try {
        const currentToken = localStorage.getItem('token');

        const response = await axiosInstance.post('/auth/jwt/refresh/', { refresh: currentToken });
        const newToken = response.data.access; 

        localStorage.setItem('token', newToken);
      } catch (error) {
        console.error(error);
      }
    };


    




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("form", {
          onSubmit: _withModifiers(loginUser, ["prevent"]),
          class: "flex flex-col justify-center items-center w-full relative max-w-[700px]"
        }, [
          _createElementVNode("div", _hoisted_5, [
            (errorMessage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(errorMessage.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginData.value.email) = $event)),
              name: "email",
              id: "email",
              class: "p-[10px] w-full rounded-[5px] border outline-none pt-[25px] bg-transparent",
              placeholder: "E.x: ironsecur@gmail.com"
            }, null, 512), [
              [_vModelText, loginData.value.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              type: showPassword.value ? 'text' : 'password',
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginData.value.password) = $event)),
              name: "password",
              id: "password",
              class: "p-[10px] w-full rounded-[5px] border outline-none pt-[25px] bg-transparent",
              placeholder: "E.x: *********"
            }, null, 8, _hoisted_11), [
              [_vModelDynamic, loginData.value.password]
            ]),
            _createElementVNode("i", {
              class: _normalizeClass(["password-toggle", showPassword.value ? 'fa fa-eye text-1xl absolute top-[45px] right-[25px]' : 'fa fa-eye-slash text-1xl absolute top-[45px] right-[25px]']),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value))
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", _hoisted_13, [
              _createElementVNode("span", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (goToResetPage())),
                class: "font-bold text-sm text-black hover:underline duration-300"
              }, "Forget password ?")
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "submit",
              disabled: loading.value,
              class: "py-[10px] min-w-[100px] px-[20px] rounded-[5px] text-sm font-bold text-white bg-cyan-500 hover:bg-cyan-600 duration-300"
            }, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                : (_openBlock(), _createElementBlock("span", _hoisted_17, "Log in"))
            ], 8, _hoisted_15)
          ])
        ], 40, _hoisted_4)
      ])
    ]),
    _hoisted_18
  ], 64))
}
}

})